<template>
    <v-autocomplete :loading="loading" :items="items" solo :value="value" label="Parliament" @input="$emit('input', $event)"></v-autocomplete>
</template>
<script>
import axios from 'axios'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ["value"],
    data: function () {
        return {
            loading: false,
            items: [],
            search: null,
            select: null
        }
    },
    created: function() {
        this.query();
    },
    methods: {
        query() {
            axios.get(`/api/reference/parliaments`)
                    .then(response => {
                        this.items = _.orderBy(response
                            .data, ["Id"], ["desc"])                            
                            .map(d => ({ 
                                value: d.Id, 
                                text: `${d.Name} (${d.DateOpening && new Date(d.DateOpening).toLocaleDateString()} to ${(d.DateDissolution
                                    && new Date(d.DateDissolution).toLocaleDateString()) || 'present' })`,
                            }));
                        this.loading = false;
                    });
        }
    }
}
</script>